const { DriverStatusServiceConnector } = require('./DriverStatusServiceConnector');
const { PhxBookingCommandServiceConnector } = require('./PhxBookingCommandServiceConnector');
const { PhxBookingQueryConnector } = require('./PhxBookingQueryConnector');
const { PhxDriverServiceConnector } = require('./PhxDriverServiceConnector');
const { PhxFareCalculatorServiceConnector } = require('./PhxFareCalculatorServiceConnector');
const { PhxFleetServiceConnector } = require('./PhxFleetServiceConnector');
const { PhxPassengerServiceConnector } = require('./PhxPassengerServiceConnector');
const { PhxCommissionCommandServiceConnector } = require('./PhxCommissionCommandServiceConnector');
const { PhxCommissionQueryConnector } = require('./PhxCommissionQueryConnector');
const { PhxTariffCommandServiceConnector } = require('./PhxTariffCommandServiceConnector');
const { PhxTariffQueryConnector } = require('./PhxTariffQueryConnector');
const { PhxTripCommandServiceConnector } = require('./PhxTripCommandServiceConnector');
const { PhxTripQueryConnector } = require('./PhxTripQueryConnector');
const { PhxVehicleCatalogServiceConnector } = require('./PhxVehicleCatalogServiceConnector');
const { PhxVehicleCommandServiceConnector } = require('./PhxVehicleCommandServiceConnector');
const { PhxVehicleQueryConnector } = require('./PhxVehicleQueryConnector');
const { SuggestionServiceConnector } = require('./SuggestionServiceConnector');
const { PhxDriverMessageCommandServiceConnector } = require('./PhxDriverMessageCommandServiceConnector');
const { PhxEarningsCalculatorServiceConnector } = require('./PhxEarningsCalculatorServiceConnector');
const { PhxDriverPaymentServiceConnector } = require('./PhxDriverPaymentServiceConnector');
const { PhxPayoutQueryConnector } = require('./PhxPayoutsQueryConnector');
const { PhxEarningQueryConnector } = require('./PhxEarningsQueryConnector');

module.exports = {
  DriverStatusServiceConnector,
  PhxBookingCommandServiceConnector,
  PhxBookingQueryConnector,
  PhxDriverServiceConnector,
  PhxEarningQueryConnector,
  PhxFareCalculatorServiceConnector,
  PhxFleetServiceConnector,
  PhxPassengerServiceConnector,
  PhxPayoutQueryConnector,
  PhxCommissionCommandServiceConnector,
  PhxCommissionQueryConnector,
  PhxTariffCommandServiceConnector,
  PhxTariffQueryConnector,
  PhxTripCommandServiceConnector,
  PhxTripQueryConnector,
  PhxVehicleCatalogServiceConnector,
  PhxVehicleCommandServiceConnector,
  PhxVehicleQueryConnector,
  SuggestionServiceConnector,
  PhxDriverMessageCommandServiceConnector,
  PhxEarningsCalculatorServiceConnector,
  PhxDriverPaymentServiceConnector,
};
